export default __webpack_public_path__ + "static/media/battery-4.0ea6b2eb.svg";